<template>
<div class="container">
	<div class="row imgdiv">
		<img :src="picurl+info.pic" alt="第一健康"/>
	</div>
	<div class="row mt" v-html="pic(info.content)" v-if="info"></div>
</div>	
</template>

<style scoped>
img{width:100%;max-width:100% !important;height:auto;}	
.mt{margin-top: 1rem;max-width:100% !important;padding-bottom: 3rem;width:98%;margin:1%;padding:.3rem .8rem;}
</style>

<script>

export default {
   data(){
   	return {
   		info:"",
   		content:"",
   		picurl:picurl,
   		mydata:mydata,
        pic:fun.contentPic,
   	}
   },
   watch: {
      '$route': 'getinfo'
    },
   created:function(){
       window.scrollTo(0,0);
      this.getinfo();
   },
   methods:{
   	getinfo:function(){
   		//this.mydata.nav="公司简介";
   		var _this=this;
         if(fun.cache(fun.url())){
            this.info=fun.cache(fun.url());return;
         }
   		fun.post(api+"thm_about",{},function(d){
   			console.log(d);
   			if(d.status==1){
   				_this.info=d.info;
   				fun.cache(fun.url(),d.info);
   			}else{
               _this.$toast(d.data.info);
            }
   		})
   	}
   }
}
	
</script>


// WEBPACK FOOTER //
// src/components/thm/about.vue